import Layout from "@/layouts/index.vue";

const routes = [
  {
    path: "/perm",
    name: "perm",
    meta: { title: "用户管理" },
    redirect: "/perm/administrator",
    component: Layout,
    children: [
      {
        path: "/perm/administrator",
        meta: {
          title: "管理列表",
          icon: "icon-zhanghuxinxi",
          parentPath: "/perm",
          permissionKey: "system.admin",
          permissionAction: "view",
        },
        component: () => import("@/views/perm/administrator/index.vue"),
      },
      {
        path: "/perm/customer",
        meta: {
          title: "子账户管理",
          icon: "icon-zhanghuxinxi",
          parentPath: "/perm",
          permissionKey: "system.customer",
          permissionAction: "view",
        },
        component: () => import("@/views/perm/customer/index.vue"),
      },
      {
        path: "/perm/administrator_detail",
        component: () => import("@/views/perm/administrator/detail.vue"),
        meta: {
          title: "",
          parentPath: "/perm",
          hidden: true,
          permissionKey: "system.admin",
          permissionAction: "view",
        },
      },
      {
        path: "/perm/customer_detail",
        component: () => import("@/views/perm/customer/detail.vue"),
        meta: {
          title: "",
          parentPath: "/perm",
          hidden: true,
          permissionKey: "system.customer",
          permissionAction: "view",
        },
      },
    ],
  },
];

export default routes;
